var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#FFC900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M621.317 325.16C621.317 328.78 617.482 331.115 614.272 329.45C603.927 324.08 589.822 318.115 572.687 317C547.552 315.36 539.087 324.23 512.587 325.195C482.537 326.29 468.602 304.58 429.537 303.885C390.612 303.195 375.992 323.01 344.847 320.825C316.712 318.85 312.642 308.09 289.117 309.895C267.807 311.535 259.052 323.955 238.852 325.74C220.277 327.38 209.097 313.74 181.482 314.81C157.287 315.75 159.637 327.165 132.307 327.925C112.637 328.47 98.1425 316.63 71.6575 317.545C55.8125 318.09 32.8625 334.485 24.6675 331.75C21.7325 330.77 18.6575 329.47 18.6575 326.375V31.2399C25.6625 31.1999 35.5975 31.2399 48.7075 32.8799C64.4375 34.8449 76.5725 42.1699 97.3375 43.2599C132.842 45.1299 143.232 29.5999 177.657 28.5099C207.162 27.4149 213.732 41.7199 251.967 41.0749C288.422 40.4599 297.317 27.4499 322.452 27.9599C349.227 28.5049 360.152 47.6649 397.852 48.1749C438.282 48.7199 455.227 30.4549 470.522 30.1449C497.297 29.5999 502.757 46.5349 543.737 46.5349C587.447 46.5349 589.632 29.0499 605.477 29.0499C612.327 29.0499 617.862 30.4249 621.322 31.2349C621.317 129.21 621.317 227.185 621.317 325.16Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M609.843 40.7591V314.644C597.468 309.324 585.473 306.329 573.438 305.539C571.138 305.389 568.863 305.314 566.673 305.314C554.928 305.314 546.423 307.454 538.208 309.519C530.443 311.474 523.113 313.324 512.173 313.714C511.583 313.734 510.988 313.749 510.403 313.749C499.438 313.749 491.033 310.019 480.398 305.289C467.228 299.439 452.303 292.804 429.743 292.399C429.013 292.389 428.278 292.384 427.558 292.384C410.113 292.384 397.153 296.109 385.918 300.094C385.878 300.109 385.838 300.119 385.798 300.139C381.993 265.614 370.358 253.219 360.768 249.199C345.933 242.489 304.668 242.989 291.073 247.544C280.238 251.179 276.698 258.044 275.708 260.674C264.348 253.639 251.178 251.599 241.678 255.274C231.043 259.384 224.298 274.124 224.298 283.979C224.293 294.214 224.248 306.249 226.903 312.934C224.508 312.234 222.003 311.329 219.238 310.329C210.528 307.184 199.688 303.269 184.558 303.269C183.398 303.269 182.213 303.289 181.033 303.339C166.783 303.889 159.348 307.799 153.368 310.934C147.843 313.834 143.483 316.124 131.988 316.449C131.648 316.459 131.308 316.459 130.983 316.459C124.143 316.459 117.603 314.509 110.028 312.254C100.223 309.329 89.1026 306.014 74.5576 306.014C73.4726 306.014 72.3626 306.029 71.2626 306.069C61.1226 306.419 50.2326 311.184 40.6226 315.389C37.4776 316.764 33.2276 318.624 30.1326 319.699V42.8641C35.0226 43.0491 40.7426 43.4441 47.2876 44.2641C52.9876 44.9741 58.2526 46.5441 64.3576 48.3541C73.2726 51.0041 83.3776 54.0091 96.7376 54.7141C98.9026 54.8291 101.053 54.8891 103.143 54.8891C120.698 54.8891 132.493 50.9191 143.903 47.0791C154.078 43.6591 163.688 40.4241 178.023 39.9691H178.083C179.008 39.9291 179.928 39.9141 180.828 39.9141C191.178 39.9141 197.888 42.1541 206.378 44.9891C217.018 48.5341 229.068 52.5641 249.488 52.5641C250.368 52.5641 251.253 52.5541 252.158 52.5441C273.323 52.1891 286.438 47.8391 296.978 44.3491C305.298 41.5941 311.873 39.4141 321.013 39.4141C321.408 39.4141 321.813 39.4191 322.213 39.4291C332.008 39.6241 339.233 42.9591 348.383 47.1841C360.118 52.5991 374.723 59.3341 397.693 59.6491C398.338 59.6541 398.983 59.6591 399.618 59.6591C426.418 59.6591 443.673 52.0791 456.273 46.5491C462.218 43.9391 467.353 41.6791 470.753 41.6141C471.098 41.6041 471.443 41.6041 471.773 41.6041C480.818 41.6041 486.563 44.0741 494.513 47.4941C505.393 52.1741 518.938 58.0041 543.733 58.0041C574.253 58.0041 587.623 49.8041 596.468 44.3791C601.223 41.4691 602.968 40.5241 605.473 40.5241C607.008 40.5241 608.468 40.6141 609.843 40.7591Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313.087 301.08C307.822 299.455 301.898 298.215 294.228 298.215C292.303 298.215 290.293 298.29 288.238 298.45C275.223 299.45 266.157 303.795 258.157 307.63C251.452 310.845 245.663 313.62 237.838 314.305C237.143 314.365 236.437 314.4 235.752 314.4C232.802 314.4 229.943 313.835 226.903 312.94C224.248 306.26 224.292 294.22 224.297 283.985C224.297 274.13 231.047 259.385 241.677 255.28C252.302 251.165 267.528 254.205 279.673 263.395C291.818 272.58 305.447 284.725 313.087 301.08Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M340.973 231.636V244.951C331.553 244.031 320.868 243.926 311.483 244.486V231.586C316.258 232.686 321.238 233.271 326.343 233.271C331.373 233.271 336.268 232.706 340.973 231.636Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.798 300.146C383.608 300.921 381.478 301.716 379.393 302.486C369.208 306.256 360.413 309.516 349.608 309.516C348.308 309.516 346.977 309.466 345.652 309.376C333.992 308.556 327.113 306.051 320.458 303.621C318.068 302.751 315.652 301.871 313.087 301.081C305.442 284.726 291.818 272.581 279.673 263.396C278.383 262.416 277.058 261.511 275.708 260.681C276.698 258.051 280.238 251.186 291.073 247.551C295.538 246.061 302.973 245.001 311.488 244.486C320.868 243.921 331.558 244.031 340.978 244.951C349.043 245.736 356.177 247.126 360.772 249.206C370.357 253.226 381.993 265.621 385.798 300.146Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5875 306.265C72.7575 300.6 74.2075 284.27 71.1175 274.375C68.3875 265.635 61.8275 258.53 39.9725 263.445C39.4275 240.495 39.4275 83.1404 39.4275 83.1404C39.4275 83.1404 61.8275 83.1404 64.0125 65.6554C79.3125 68.9354 118.102 77.1304 137.772 76.0354C157.442 74.9404 174.472 57.5854 216.997 67.2954C267.262 78.7704 286.932 56.3654 315.347 58.5554C343.762 60.7454 384.618 74.5504 411.508 71.6704C442.103 68.3904 469.372 47.4554 505.482 62.3804C546.462 79.3204 579.242 62.9254 579.242 62.9254C579.242 62.9254 585.253 78.7704 602.193 79.8654C602.193 89.7004 601.098 278.2 601.098 278.2C601.098 278.2 590.148 274.425 581.973 279.295C576.273 282.685 570.993 293.345 577.383 305.885",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M602.198 288.958C597.643 285.573 590.388 282.428 586.458 285.393C582.528 288.353 592.133 293.383 597.038 294.763C603.468 296.568 603.923 302.133 598.003 301.593C590.688 300.928 584.883 294.218 584.883 294.218",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M593.258 281.609V308.844",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M599.988 44.25V71.12",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M606.198 47.3047C606.198 47.3047 592.818 49.5247 591.868 53.5097C590.678 58.5247 595.488 57.9047 601.643 56.2497C607.798 54.5947 609.127 59.8247 605.727 62.1447C600.192 65.9197 592.278 65.2497 592.278 65.2497",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4075 49.332V76.097",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1675 55.0588C53.2275 51.7788 44.5125 50.6538 42.0675 52.9538C39.6225 55.2538 42.5275 59.9688 51.0725 61.4688C60.5625 63.1338 58.9425 70.8988 48.0875 69.7388C41.6775 69.0538 37.2225 66.4138 37.2225 66.4138",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4226 268.496V300.621",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5226 270.723C52.0926 269.128 40.0976 275.833 39.4226 281.343C38.7476 286.853 46.4776 286.748 53.7526 283.268C61.7226 279.458 68.0526 283.758 62.3176 290.768C55.6276 298.948 46.1176 298.468 46.1176 298.468",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.857 78.082L199.777 82.332L205.882 84.347L200.267 88.377L202.667 95.242L195.312 90.722L189.537 95.242L191.662 88.212L187.412 84.347L194.492 84.237L195.857 78.082Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.392 106.703L177.162 113.248L183.497 114.103L177.377 116.878L178.447 123.638L172.112 118.443L164.357 123.068L168.627 116.098L163.292 111.828L170.547 113.038L173.392 106.703Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.587 225.094L174.922 232.134L183.327 232.894L178.632 235.999L182.797 242.509L174.847 239.404L166.062 246.294L168.107 238.724L160.912 236.754L167.577 233.799L171.587 225.094Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M192.872 257.43L191.098 264.725L185.062 268.61H191.143L189.598 275.11L195.773 269.405L204.008 274.08L199.467 267.86L204.383 262.95L197.598 264.63L192.872 257.43Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M541.707 88.5312L538.852 97.4113L531.047 98.3663L537.202 101.286L534.917 108.266L542.277 102.236L550.527 106.236L547.737 101.221L554.717 96.9712L544.692 96.3362L541.707 88.5312Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M561.547 129.023L566.097 134.603H573.192L568.327 138.753L574.632 145.373L566.177 142.583L562.107 149.043L560.912 142.023L553.172 142.583L559.632 137.238L561.547 129.023Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M570.242 175.445C570.242 175.445 565.537 180.79 565.057 184.3C563.222 184.86 557.718 188.61 557.718 188.61L567.052 191.24L566.177 198.98L572.878 192.04L580.932 197.705L576.468 188.29L583.568 184.38L573.117 183.9L570.242 175.445Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M564.328 221.141L561.173 226.861L550.893 228.381L557.718 233.171L554.398 238.311L562.808 234.106L569.583 240.061L567.128 232.121L575.423 229.901L565.258 228.496L564.328 221.141Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M536.912 259.953L531.992 269.218L522.562 270.288L528.383 274.468L525.513 280.868L534.042 274.553L539.862 280.868L538.883 273.158L545.198 269.958L536.833 268.153L536.912 259.953Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M473.893 201.672C486.689 201.672 497.063 191.298 497.063 178.502C497.063 165.706 486.689 155.332 473.893 155.332C461.096 155.332 450.723 165.706 450.723 178.502C450.723 191.298 461.096 201.672 473.893 201.672Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M463.013 168.711H485.983L483.998 172.141C483.718 172.626 483.568 173.171 483.563 173.731L483.423 187.946C483.423 187.946 475.158 189.261 475.158 194.456C475.158 189.411 466.818 186.261 466.818 186.261V174.416C466.818 173.656 466.548 172.921 466.063 172.336L463.013 168.711Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M469.773 168.711V187.711",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M474.493 168.711L475.153 194.461",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M478.728 168.711L479.443 189.186",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.053 205.785C165.061 205.785 176.418 194.428 176.418 180.42C176.418 166.411 165.061 155.055 151.053 155.055C137.044 155.055 125.688 166.411 125.688 180.42C125.688 194.428 137.044 205.785 151.053 205.785Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.313 182.543C134.313 177.318 139.023 171.443 142.863 171.443C145.673 171.443 148.903 172.838 148.823 171.573C148.648 168.808 146.523 167.958 144.808 167.428C145.368 164.928 149.983 163.968 154.138 165.698C155.693 166.348 155.433 171.703 155.433 171.703C155.433 171.703 161.478 170.103 164.113 171.833C166.278 173.253 167.398 175.298 167.603 177.403C167.728 178.648 167.408 179.253 165.948 179.408C163.258 179.688 159.493 180.003 159.493 180.003V182.163L163.638 183.308V193.133L159.128 193.708C158.463 193.793 157.818 193.993 157.218 194.303C155.933 194.968 153.703 196.318 152.153 198.358C151.013 196.433 148.878 195.023 147.578 194.293C146.933 193.933 146.223 193.703 145.488 193.613L138.498 192.743V184.063L142.948 182.593C142.948 182.593 142.948 180.728 142.948 179.568C142.948 178.408 140.138 178.273 138.933 179.053C137.723 179.823 134.313 182.543 134.313 182.543Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.313 177.699C138.143 176.319 141.108 173.284 141.108 173.284H150.798C150.798 173.284 150.798 170.734 150.798 170.354C150.798 169.974 150.263 167.904 148.248 167.904C148.248 167.179 148.248 166.734 148.248 166.734H153.213C154.488 166.734 155.323 170.874 153.213 170.874C153.213 171.289 153.213 173.184 153.213 173.184C153.213 173.184 160.938 173.184 162.073 173.184C163.213 173.184 165.658 177.699 165.658 177.699C165.658 177.699 160.863 177.699 159.658 177.699C158.453 177.699 157.763 181.184 157.763 181.184H145.108C145.108 181.184 145.468 177.939 143.903 177.634C141.073 177.079 137.313 177.699 137.313 177.699Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M143.658 185.336V191.386C142.253 191.136 140.878 190.981 139.713 190.941V185.336H143.658V185.336Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.028 185.333V192.778H148.808C147.693 192.333 146.403 191.963 145.088 191.668V185.328H149.028V185.333Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M157.903 185.336V192.096C157.178 192.306 156.483 192.531 155.848 192.786H154.653V185.341H157.903V185.336Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.753 185.336V191.261C160.933 191.391 160.088 191.556 159.258 191.751V185.336H161.753V185.336Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.668 185.336V193.886C152.968 194.361 152.503 194.881 152.373 195.431C152.338 195.536 152.328 195.646 152.328 195.751C152.328 195.641 152.318 195.531 152.288 195.431C152.108 194.686 151.323 194.006 150.188 193.406V185.336H153.668Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4725 289.802C102.673 285.507 107.438 281.552 119.178 277.392C130.918 273.232 136.618 268.537 137.088 266.192C137.558 263.847 111.668 277.392 96.5075 290.342",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.323 285.703C107.928 283.988 123.873 281.238 127.033 280.688C114.113 284.583 109.303 287.883 109.898 289.623C110.493 291.363 135.098 280.508 135.098 280.508",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M126.388 284.222C124.658 287.102 126.193 287.792 138.173 283.757C141.313 282.702 145.503 282.062 142.523 288.887",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138.022 299.33C142.827 291.63 158.537 274.625 173.632 273.48C179.047 273.02 167.837 286.765 158.992 290.34C150.147 293.915 144.202 293.225 138.022 299.33Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M146.443 294.228C146.443 294.228 168.068 275.383 169.213 274.238",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M162.607 288.422C164.582 289.262 162.327 293.042 157.042 294.227C162.762 292.467 173.077 288.727 177.412 286.392C182.182 286.572 195.877 285.992 195.877 285.992",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M232.248 262.605C226.203 281.27 228.553 300.95 237.843 314.305Z",
    fill: "#FF7051"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M232.248 262.605C226.203 281.27 228.553 300.95 237.843 314.305",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M249.122 292.265C249.122 289.345 251.503 289.695 250.043 285.66C248.583 281.63 242.418 282.435 239.333 285.43C236.723 287.965 235.263 296.785 241.598 298.52C248.318 300.365 249.122 292.265 249.122 292.265Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M258.083 273.513C260.768 272.328 261.233 274.248 264.463 271.523C267.693 268.798 264.913 264.513 261.143 263.423C257.948 262.498 249.353 264.993 249.843 270.433C250.363 276.198 258.083 273.513 258.083 273.513Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M289.016 288.207C291.166 285.729 290.493 281.624 287.512 279.038C284.532 276.452 280.373 276.364 278.222 278.842C276.072 281.319 276.745 285.425 279.726 288.011C282.706 290.597 286.866 290.685 289.016 288.207Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M348.258 267.597C351.303 261.877 354.543 251.457 354.543 239.982C354.543 233.547 348.193 236.397 347.928 245.822C348.678 237.552 345.128 233.812 340.938 236.407C336.218 239.332 339.538 262.292 339.538 262.292L339.063 264.197L341.118 267.957L348.258 267.597Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M301.873 245.359C292.313 236.274 282.238 242.389 288.268 250.234C294.048 257.999 332.038 273.689 332.038 273.689C330.593 280.004 337.638 282.494 337.638 282.494C337.638 282.494 331.103 289.444 330.608 293.254C330.113 297.064 334.528 298.169 337.128 294.744C339.728 291.319 345.083 279.884 345.083 279.884C348.343 287.289 345.228 294.009 349.338 294.799C354.198 295.739 355.503 291.649 355.193 285.684C354.873 279.504 350.773 278.724 350.773 278.724C355.633 278.004 355.538 274.379 353.093 272.124C350.088 269.354 345.248 264.749 345.248 264.749C345.248 264.749 342.693 263.769 336.243 260.799C329.788 257.829 312.978 247.689 311.598 244.484C311.088 243.074 311.228 239.204 307.133 237.859C303.333 236.609 298.668 239.224 301.873 245.359Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M345.243 264.743C345.243 264.743 336.098 264.493 332.038 273.683",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M337.633 282.492C337.633 282.492 342.753 278.762 344.323 278.292C345.898 277.822 350.763 278.727 350.763 278.727",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M325.733 270.992L326.698 305.802",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M319.172 282.069C320.561 282.069 321.687 280.943 321.687 279.554C321.687 278.165 320.561 277.039 319.172 277.039C317.783 277.039 316.657 278.165 316.657 279.554C316.657 280.943 317.783 282.069 319.172 282.069Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M319.042 292.005C320.503 292.005 321.687 290.821 321.687 289.36C321.687 287.899 320.503 286.715 319.042 286.715C317.582 286.715 316.397 287.899 316.397 289.36C316.397 290.821 317.582 292.005 319.042 292.005Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M368.052 306.456L378.413 244.141L387.087 245.236L376.408 303.586L368.052 306.456Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M376.203 257.417L384.383 260.022L385.138 255.882L376.867 253.422L376.203 257.417Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M384.113 244.855L382.798 249.59L382.628 244.68C382.613 244.26 382.943 243.91 383.358 243.895C383.778 243.88 384.128 244.21 384.143 244.625C384.143 244.705 384.128 244.785 384.113 244.855Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M380.898 244.425L379.723 249.375L379.403 244.295C379.378 243.875 379.693 243.515 380.113 243.49C380.533 243.465 380.893 243.78 380.918 244.2C380.918 244.28 380.913 244.355 380.898 244.425Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M390.133 218.98C384.468 222.105 386.038 227.3 380.668 231.255C375.298 235.21 373.698 241.47 378.408 244.145C383.118 246.82 388.883 246.12 392.313 241.11C394.498 237.925 394.113 232.94 392.078 230.075C390.193 227.42 388.483 222.58 390.133 218.98Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6476 113.444C67.6476 113.444 67.6476 105.124 67.6476 103.899C67.6476 102.474 74.2126 101.219 75.1726 102.869C76.5576 105.244 72.7176 106.989 67.1726 107.834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8825 106.359C77.3425 107.124 76.3375 111.279 74.0375 111.849C71.5375 112.464 67.6475 111.919 67.6475 111.919",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3076 105.355C81.1676 100.885 84.1676 101.6 84.0226 103.725C83.8776 105.85 79.6626 111.555 79.6626 111.555H86.9226",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M106.103 112.54C106.103 112.54 107.333 108.595 107.553 104.165C108.448 103.68 112.578 102.75 112.578 102.75V112.535",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M107.133 107.98H112.578",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M120.392 107.2C120.392 107.2 122.957 107.695 121.757 109.815C120.557 111.93 116.132 111.9 116.132 111.9V103.93C118.052 102.375 122.257 101.9 122.382 103.5C122.547 105.55 121.917 107.985 115.667 107.985",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M139.872 107.2C139.872 107.2 142.437 107.695 141.237 109.815C140.037 111.93 135.612 111.9 135.612 111.9V103.93C137.532 102.375 141.737 101.9 141.862 103.5C142.027 105.55 141.397 107.985 135.147 107.985",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M133.108 102.75H128.108L126.348 111.895H132.313",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M127.278 107.062H131.623",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M145.323 104.415C146.713 101.32 150.518 102.685 149.358 105.435C148.193 108.19 146.318 111.895 146.318 111.895H150.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M392.178 167.435C392.178 198.77 370.288 224.985 340.973 231.635C336.268 232.705 331.373 233.27 326.348 233.27C321.238 233.27 316.263 232.685 311.488 231.585C282.283 224.85 260.518 198.68 260.518 167.435C260.518 157.54 262.703 148.15 266.618 139.73L383.018 133.91C388.833 143.725 392.178 155.19 392.178 167.435Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M266.608 139.731C270.433 132.566 269.063 129.456 263.913 129.391C257.048 129.306 237.058 135.996 228.308 126.561C219.558 117.126 225.903 105.656 237.658 100.736C256.328 92.9314 275.233 92.1564 288.448 90.6964C301.658 89.2364 319.988 86.8264 319.988 86.8264C319.988 86.8264 312.743 81.2714 313.438 77.6964C314.133 74.1214 322.468 73.7264 326.138 86.0314C326.138 86.0314 348.862 84.2464 366.622 83.8464C384.387 83.4514 403.382 85.4314 407.462 91.5414C410.852 96.6264 406.723 110.831 399.513 114.436C392.303 118.041 382.503 126.871 383.003 133.901",
    fill: "#FF7051"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M266.608 139.731C270.433 132.566 269.063 129.456 263.913 129.391C257.048 129.306 237.058 135.996 228.308 126.561C219.558 117.126 225.903 105.656 237.658 100.736C256.328 92.9314 275.233 92.1564 288.448 90.6964C301.658 89.2364 319.988 86.8264 319.988 86.8264C319.988 86.8264 312.743 81.2714 313.438 77.6964C314.133 74.1214 322.468 73.7264 326.138 86.0314C326.138 86.0314 348.862 84.2464 366.622 83.8464C384.387 83.4514 403.382 85.4314 407.462 91.5414C410.852 96.6264 406.723 110.831 399.513 114.436C392.303 118.041 382.503 126.871 383.003 133.901",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M310.853 183.113C313.056 183.113 314.843 181.326 314.843 179.123C314.843 176.919 313.056 175.133 310.853 175.133C308.649 175.133 306.863 176.919 306.863 179.123C306.863 181.326 308.649 183.113 310.853 183.113Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M339.093 183.113C341.296 183.113 343.083 181.326 343.083 179.123C343.083 176.919 341.296 175.133 339.093 175.133C336.889 175.133 335.103 176.919 335.103 179.123C335.103 181.326 336.889 183.113 339.093 183.113Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M317.828 190.781H334.242",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M319.118 232.992C322.958 241.772 330.053 238.622 331.043 233.267L319.118 232.992Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid14);
export default __webpack_public_path__ + "static/media/grid14.23485d2cea2976c408474b91631e4b69.svg";
export { ForwardRef as ReactComponent };